import { sessionSave as save, sessionLoad as load } from 'Core/Utils/Session';
import UiInitialState from 'RLX/State/Ui/UiInitialState';

const SidebarReducer = (state = UiInitialState, { type, payload } = {}) => {
  switch (type) {
    case 'ui/sidebar/PAGES_LIST_EXPANDED': {
      const pagesListCollapsed = false;
      save('pagesListCollapsed', pagesListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, pagesListCollapsed } };
    }

    case 'ui/sidebar/PAGES_LIST_COLLAPSED': {
      const pagesListCollapsed = true;
      save('pagesListCollapsed', pagesListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, pagesListCollapsed } };
    }

    case 'ui/sidebar/BLOGS_LIST_EXPANDED': {
      const blogsListCollapsed = false;
      save('blogsListCollapsed', blogsListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, blogsListCollapsed } };
    }

    case 'ui/sidebar/BLOGS_LIST_COLLAPSED': {
      const blogsListCollapsed = true;
      save('blogsListCollapsed', blogsListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, blogsListCollapsed } };
    }

    case 'ui/sidebar/ASSETS_LIST_EXPANDED': {
      const assetsListCollapsed = false;
      save('assetsListCollapsed', assetsListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, assetsListCollapsed } };
    }

    case 'ui/sidebar/ASSETS_LIST_COLLAPSED': {
      const assetsListCollapsed = true;
      save('assetsListCollapsed', assetsListCollapsed);
      return { ...state, sidebar: { ...state.sidebar, assetsListCollapsed } };
    }

    default:
      return state;
  }
};

export default SidebarReducer;



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/Sidebar/SidebarReducer.js